import { render, staticRenderFns } from "./PointsOfSale.vue?vue&type=template&id=29968b3a&scoped=true"
import script from "./PointsOfSale.vue?vue&type=script&lang=js"
export * from "./PointsOfSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29968b3a",
  null
  
)

export default component.exports